import React, { useEffect, useMemo, useCallback, useRef, useState } from 'react'
const project = require('EurestoConfig/project.config')
import ApiRequest from "EurestoApi/ApiRequest";
import MainForm from 'EurestoComponents/MainForm'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import { Grid } from '@material-ui/core'
import DataComponent from 'EurestoComponents/DataComponents'
import Input from 'Components/Input'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'
import InputClient from 'EurestoComponents/InputClient'
import Detail from '../../Component/Detail'
import moment from 'moment'

moment.locale('fr')

export default React.memo(props => {
    console.log(props)
    const document = useRef({})
    const $document = useRef({})
    const [disabled, setDisabled] = useState(props.route.action !== "add")
    const action = useRef(props.route.action || 'view')
    const [key, setKey] = useState(Utils.uuidv4())

    useEffect(() => {
        if (props.params.id) {
            ApiRequest(project.api + 'gestion', {
                requete: 'document',
                action: 'get',
                id: props.params.id
            }, { showAlertError: false, returnAnyway: true })
                .then((doc) => {
                    if (doc.code === 1) {
                        document.current = doc.results
                        $document.current = doc.results
                        setKey(Utils.uuidv4())
                    }
                    console.log(doc)
                })
        } else {
            const lieux = Data.list(Constants.module.GESTION, Constants.donnee.lieu, { principal: 1 })
            console.log(lieux)
            if (lieux.length === 1) {
                document.current = {
                    lieu_id: lieux[0].id,
                    origine: 'web'
                }
                console.log("lieux", document.current)
                setKey(Utils.uuidv4())
            }
        }
    }, [])

    const OngletDetails = useCallback(() => <Detail document={document.current} disabled={false} name={"details"} onChange={onChange} />, [disabled])

    const constObject = useMemo(() => ({
        mainForm: {
            mainTabProps: {
                style: {
                    padding: '0 65px 0 35px'
                }
            },
            isAllow: {
                update: action.current === 'view' && document.current.niveau !== 0 && document.niveau !== 2,
                add: action.current === 'add',

            },
            libelle: props.params.id ? `#${document.current.reference || ''}` : "Nouveau document",
            eurestoBodyStyle: { padding: 0 },
            style: {
                padding: 10,
                paddingTop: 0,
                top: 0,
                position: 'relative'
            },
            tabs: [{
                value: 0,
                label: EurestoI18n.t('Détail'),
                component: OngletDetails
            }],
            value: 0
        },
        ficheChildren: {
            style: {
                margin: 0,
                padding: 7.5,
                paddingTop: 19,
                maxHeight: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'left'
            }
        }
    }), [key])

    useEffect(() => {
        return () => action.current === 'update' && onCancel()
    }, [])

    const onSave = useCallback(() => {
        ApiRequest(project.api + 'gestion', {
            requete: 'document',
            action: action.current,
            date_stock: moment().format('YYYY-MM-DD HH:mm:ss'),
            ...(document.current || {}),
            niveau: 1
        }, { showAlertError: false, returnAnyway: true })
            .then((doc) => {
                if (doc.code === 1) {
                    $document.current = document.current
                    action.current = 'view'
                    setDisabled(true)
                    setKey(Utils.uuidv4())
                }
                console.log(doc)
            })
    }, [])
    const onCancel = useCallback(() => {
        console.log($document.current)
        ApiRequest(project.api + 'gestion', {
            requete: 'document',
            action: 'update',
            id: props.params.id,
            niveau: $document.current.niveau
        }, { showAlertError: false, returnAnyway: true })
            .then((doc) => {
                if (doc.code === 1) {
                    document.current = $document.current
                    action.current = 'view'
                    setDisabled(true)
                    setKey(Utils.uuidv4())
                }
            })
    }, [])
    const onLock = useCallback(() => {
        ApiRequest(project.api + 'gestion', {
            requete: 'document',
            action: 'update',
            id: props.params.id,
            niveau: 0
        }, { showAlertError: false, returnAnyway: true })
            .then((doc) => {
                if (doc.code === 1) {
                    $document.current = document.current
                    action.current = 'update'
                    setDisabled(false)
                    setKey(Utils.uuidv4())
                }
                console.log(doc)
            })
    }, [])

    const onChange = useCallback((data, name) => {
        document.current[name] = data
        console.log(name, data)
        if (name === 'type') {
            if (document.current.mouvement_id) {
                const mouvement = Data.list(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: document.current.mouvement_id })
                console.log(mouvement)
                if (mouvement && Constants.typeMouvementStock[document.current.type].indexOf(mouvement.type) === -1) {
                    document.current.mouvement_id = undefined
                }
            }
            console.log("document", document.current)
            setKey(Utils.uuidv4())
        } else if (name === 'mouvement_id') {
            const mouvement = Data.list(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: data })
            if (mouvement && mouvement.lieu_id) {
                document.current.lieu_id = mouvement.lieu_id
                setKey(Utils.uuidv4())
            }
        } else if (name === 'fournisseur_id') {
            setKey(Utils.uuidv4())
        }
    })

    console.log(document.current)

    const FicheChildren = useCallback(() => <Grid direction={'column'} container justify={'flex-start'}
        alignContent={'flex-start'}
        wrap={'nowrap'}
        alignItems={'stretch'}
        style={constObject.ficheChildren.style}
        spacing={0}>
        <Input
            onChange={onChange}
            inline
            name="reference"
            disabled={disabled}
            type="text"
            value={document.current.reference}
            title={EurestoI18n.t('commun:Référence')}
        />
        <Select
            inline
            title={EurestoI18n.t('commun:Type')}
            name="type"
            disabled={disabled}
            options={Object.keys(Constants.typeDocumentStock).map(k => ({
                label: k,
                value: Constants.typeDocumentStock[k]
            }))}
            value={document.current.type}
            onChange={onChange} />
        <DataComponent
            key={key + '-' + document.current.type + '-typeMouvement'}
            inline
            title={EurestoI18n.t('commun:Mouvement')}
            name="mouvement_id"
            disabled={disabled}
            columnOptions={'abrege'}
            type={Constants.typeSaisie.ComboSimple}
            onChange={onChange}
            data={document.current.mouvement_id}
            object={Constants.donnee.type_mouvement}
            module={Constants.module.GESTION}
            search={{ type: { in: Constants.typeMouvementStock[document.current.type] } }}
        />
        <DataComponent
            inline
            title={EurestoI18n.t('commun:Lieu')}
            name="lieu_id"
            columnOptions={'abrege'}
            disabled={disabled}
            type={Constants.typeSaisie.ComboSimple}
            onChange={onChange}
            data={document.current.lieu_id}
            object={Constants.donnee.lieu}
            module={Constants.module.GESTION}
        />

        <InputClient title={EurestoI18n.t('commun:Fournisseur')} search={{ disabled: { qualite_id: true } }} inline defaultSearch={{ qualite_id: [4] }} name={"fournisseur_id"} contact_id={document.current.fournisseur_id} onChange={onChange} />

        <Select title={EurestoI18n.t('crm:Origine')}
            name="origine"
            disabled={true}
            onChange={onChange}
            inline
            value={document.current.origine}
            options={[{
                value: 'euresto',
                label: 'Euresto'
            }, {
                value: 'mobile',
                label: 'Mobile'
            }, {
                value: 'web',
                label: 'Web'
            }]} />
        {/* <Select title={EurestoI18n.t('crm:Niveau')} name="niveau"
            onChange={onChange}
            inline
            disabled={disabled}
            value={document.current.niveau}
            options={[{
                value: -1,
                label: 'À compléter'
            }, {
                value: 0,
                label: 'Bloqué'
            }, {
                value: 1,
                label: 'À valider'
            }, {
                value: 2,
                label: 'Validé'
            },]} /> */}
    </Grid>, [disabled, key])

    return <React.Fragment>
        <MainForm
            key={key + `${disabled ? "-ooo" : "-nnn"}`}
            mainTabProps={constObject.mainForm.mainTabProps}
            isAllow={constObject.mainForm.isAllow}
            libelle={constObject.mainForm.libelle}
            action={action.current}
            eurestoBodyStyle={constObject.mainForm.eurestoBodyStyle}
            style={constObject.mainForm.style}
            onClickUpdate={disabled}
            onSave={onSave}
            onUpdate={onLock}
            onCancel={onCancel}
            onView={onCancel}
            modalHeight={props.modalHeight}
            value={constObject.mainForm.value}
            tabs={constObject.mainForm.tabs}
            general={FicheChildren}
        />
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/Stock/Page/Document/index.js